import { KYMW2700Model } from '../kymw2700.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 基版コピー・フェーズ管理画面　確定フェーズコンボボックス情報を取得するサービス
 *
 * @export InitFixationPhaseComboService
 * @class InitFixationPhaseComboService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class InitFixationPhaseComboService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW2700Model}
   * @memberof InitFixationPhaseComboService
   */
  private model: KYMW2700Model;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof InitFixationPhaseComboService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof InitFixationPhaseComboService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof InitFixationPhaseComboService
   */
  execute(model: any, successFunc: Function): void {
    this.model = <KYMW2700Model> model;
    this.successFunc = successFunc;
    this.send('initFixationPhaseCombo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof InitFixationPhaseComboService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }

}
